import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-danger dark:text-danger-dark ml-0.5"
}
const _hoisted_2 = {
  key: 0,
  class: "base-input-icon left"
}
const _hoisted_3 = ["type", "value", "placeholder", "disabled", "required", "autocomplete", "name"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = {
  key: 2,
  class: "base-input-icon right"
}
const _hoisted_6 = {
  key: 1,
  class: "base-input-hint"
}
const _hoisted_7 = {
  key: 2,
  class: "base-input-error"
}

import { ref, computed, type Component } from 'vue'
import { Eye, EyeOff } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
    modelValue: {},
    label: {},
    type: { default: 'text' },
    placeholder: {},
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: {},
    hint: {},
    name: {},
    autocomplete: { default: 'off' },
    leftIcon: {},
    rightIcon: {},
    inputClass: {},
    containerClass: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props



const inputId = `input-${Math.random().toString(36).slice(2, 9)}`
const showPassword = ref(false)
const isFocused = ref(false)

const computedType = computed(() => {
  if (props.type === 'password') {
    return showPassword.value ? 'text' : 'password'
  }
  return props.type
})

const hasValue = computed(() => props.modelValue && props.modelValue.length > 0)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input-wrapper", { 'has-error': _ctx.error, 'has-value': hasValue.value, 'is-focused': isFocused.value }])
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: inputId,
          class: "base-input-label"
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["base-input-container", _ctx.containerClass])
    }, [
      (_ctx.leftIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.leftIcon), { class: "h-5 w-5" }))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        id: inputId,
        type: computedType.value,
        value: _ctx.modelValue,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        required: _ctx.required,
        autocomplete: _ctx.autocomplete,
        name: _ctx.name,
        class: _normalizeClass(["base-input-field", [_ctx.inputClass, { 'has-left-icon': _ctx.leftIcon, 'has-right-icon': _ctx.rightIcon || _ctx.type === 'password' }]]),
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value))),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (isFocused.value = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (isFocused.value = false))
      }, null, 42, _hoisted_3),
      (_ctx.type === 'password')
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "base-input-icon right base-input-toggle",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showPassword.value = !showPassword.value)),
            tabindex: "-1",
            "aria-label": showPassword.value ? 'Hide password' : 'Show password'
          }, [
            (!showPassword.value)
              ? (_openBlock(), _createBlock(_unref(Eye), {
                  key: 0,
                  class: "h-5 w-5"
                }))
              : (_openBlock(), _createBlock(_unref(EyeOff), {
                  key: 1,
                  class: "h-5 w-5"
                }))
          ], 8, _hoisted_4))
        : (_ctx.rightIcon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.rightIcon), { class: "h-5 w-5" }))
            ]))
          : _createCommentVNode("", true)
    ], 2),
    (_ctx.hint && !_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})